import {Link, Outlet} from "react-router";
import {ShieldX} from "lucide-react";
import {useCampaign} from "@/campaigns/CampaignContextHooks.ts";
import {Button} from "@/components/ui/button.tsx";

export default function GameMasterGuard() {
    const {campaign, isGameMaster, campaignPath} = useCampaign();
    if (isGameMaster) return <Outlet/>;

    return <main className="grid min-h-full place-content-center gap-4 p-6 text-center">
        <title>Kein Zugriff | DireDawn</title>
        <ShieldX className="mx-auto size-12 text-destructive"/>
        <h1 className="text-xl font-semibold">Spielleiterbereich</h1>
        <p className="text-muted-foreground">Du bist in „{campaign.title}“ als Spieler eingetragen.</p>
        <Button asChild><Link to={campaignPath("player")}>Zur Spieleransicht</Link></Button>
    </main>;
}
